var metaInfo={
    title:"智能家庭及商业应用_Movibot服务行业",
    keywords:"协作机器人_智能家居_智能家庭及商业应用",
    description:"协作机器人用于智能家居及商业领域，赋能家居进化、商业应用。协作机器人可完成煮面、煎蛋、制作冰淇淋、调制饮料等工作",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/3.js